









































import { Component, Prop, Vue } from 'vue-property-decorator';
import ImageUploadStore, {
  ImageUploadInterface,
  UploadFolderName,
} from '@/resource/file-upload/file-upload.store';
import BeatLoader from 'vue-spinner/src/BeatLoader.vue';

@Component({
  components: { BeatLoader },
})
export default class AddQuestionUpload extends Vue {
  @Prop({ default: false })
  isPreCollectionUpload!: boolean;

  @Prop({ default: false })
  isBlogUpload!: boolean;

  imageUploadStore: ImageUploadInterface = ImageUploadStore;
  isLoadingUpload = false;
  files: any = null;

  get fileUploaded() {
    return this.imageUploadStore.response;
  }

  async submitFile() {
    if (this.isLoadingUpload) return;

    const imageSize = this.files[0].size;
    if (imageSize > 0.5e7) {
      this.$toasted.global.mainToast({
        message: 'Error: File is more than 5mb',
      });
      return;
    }

    let folderName: UploadFolderName | null = null;

    if (this.isPreCollectionUpload) {
      folderName = UploadFolderName.preCollectionFolder;
    } else if (this.isBlogUpload) {
      folderName = UploadFolderName.blogFolder;
    }

    this.isLoadingUpload = true;
    await this.imageUploadStore.imageUpload({ files: this.files, folderName });
    this.isLoadingUpload = false;
  }

  handleFileUpload(files: any) {
    this.files = files;
  }
}
